// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"4b0b996f021718a37b87","801":"daf013a7dc511da3b12f"}[chunkId] + ".js";
};